export function toIntegerPrice(value: number): number {
  return Math.round(+value * 10 * 10);
}

export function toDecimalPrice(value: number): number {
  return value / 100;
}
